const locationsEs = [
  {
    "id": 29509,
    "city": "Amman",
    "address": "",
    "code": "AMM",
    "value": "AMM",
    "destination_translations": "",
    "language": "es",
    "country": "Jordanien"
  },
  {
    "id": 29503,
    "city": "Amsterdam",
    "address": "",
    "code": "AMS",
    "value": "AMS",
    "destination_translations": "",
    "language": "es",
    "country": "Niederlande"
  },
  {
    "id": 29494,
    "city": "Ankara",
    "address": "",
    "code": "ESB",
    "value": "ESB",
    "destination_translations": "",
    "language": "es",
    "country": "Türkei"
  },
  {
    "id": 29485,
    "city": "Antalya",
    "address": "",
    "code": "AYT",
    "value": "AYT",
    "destination_translations": "",
    "language": "es",
    "country": "Türkei"
  },
  {
    "id": 29477,
    "city": "Atena",
    "address": "",
    "code": "ATH",
    "value": "ATH",
    "destination_translations": "",
    "language": "es",
    "country": "Grecia"
  },
  {
    "id": 29471,
    "city": "Barcelona",
    "address": "",
    "code": "BCN",
    "value": "BCN",
    "destination_translations": "",
    "language": "es",
    "country": "Spanien"
  },
  {
    "id": 29463,
    "city": "Bari",
    "address": "",
    "code": "BRI",
    "value": "BRI",
    "destination_translations": "",
    "language": "es",
    "country": "Italia"
  },
  {
    "id": 29457,
    "city": "Beirut",
    "address": "",
    "code": "BEY",
    "value": "BEY",
    "destination_translations": "",
    "language": "es",
    "country": "Líbano"
  },
  {
    "id": 29446,
    "city": "Belgrad",
    "address": "",
    "code": "BEG",
    "value": "BEG",
    "destination_translations": "",
    "language": "es",
    "country": "Serbia"
  },
  {
    "id": 29436,
    "city": "Bilbao",
    "address": "",
    "code": "BIO",
    "value": "BIO",
    "destination_translations": "",
    "language": "es",
    "country": "Spanien"
  },
  {
    "id": 29422,
    "city": "Bodrum",
    "address": "",
    "code": "BJV",
    "value": "BJV",
    "destination_translations": "",
    "language": "es",
    "country": "Türkei"
  },
  {
    "id": 29414,
    "city": "Bologna",
    "address": "",
    "code": "BLQ",
    "value": "BLQ",
    "destination_translations": "",
    "language": "es",
    "country": "Italia"
  },
  {
    "id": 29406,
    "city": "Brindisi",
    "address": "",
    "code": "BDS",
    "value": "BDS",
    "destination_translations": "",
    "language": "es",
    "country": "Italia"
  },
  {
    "id": 29397,
    "city": "Bruxelles",
    "address": "",
    "code": "BRU",
    "value": "BRU",
    "destination_translations": "",
    "language": "es",
    "country": "Belgien"
  },
  {
    "id": 29388,
    "city": "Bucuresti",
    "address": "",
    "code": "OTP",
    "value": "OTP",
    "destination_translations": "București\nBucuresti\nBucharest\nBucarest\nBukarest\nHenri Coanda\nHenri Coandă\nRoumanie\nRomânia\nRomania",
    "language": "es",
    "country": "Rumänien"
  },
  {
    "id": 29381,
    "city": "Budapesta",
    "address": "",
    "code": "BUD",
    "value": "BUD",
    "destination_translations": "",
    "language": "es",
    "country": "Ungarn"
  },
  {
    "id": 29371,
    "city": "Cagliari",
    "address": "Cagliari Elmas Airport",
    "code": "CAG",
    "value": "CAG",
    "destination_translations": "",
    "language": "es",
    "country": "Italia"
  },
  {
    "id": 29362,
    "city": "Cairo",
    "address": "",
    "code": "CAI",
    "value": "CAI",
    "destination_translations": "",
    "language": "es",
    "country": "Ägypten"
  },
  {
    "id": 29353,
    "city": "Catania",
    "address": "",
    "code": "CTA",
    "value": "CTA",
    "destination_translations": "",
    "language": "es",
    "country": "Italia"
  },
  // {
  //   "id": 29345,
  //   "city": "Chisinau",
  //   "address": "",
  //   "code": "KIV",
  //   "value": "KIV",
  //   "destination_translations": "",
  //   "language": "es",
  //   "country": "Moldavia"
  // },
  {
    "id": 29339,
    "city": "Cluj-Napoca",
    "address": "",
    "code": "CLJ",
    "value": "CLJ",
    "destination_translations": "",
    "language": "es",
    "country": "Rumänien"
  },
  {
    "id": 29325,
    "city": "Detroit",
    "address": "",
    "code": "DTW",
    "value": "DTW",
    "destination_translations": "",
    "language": "es",
    "country": "Vereinigte Staaten"
  },
  {
    "id": 29316,
    "city": "Frankfurt",
    "address": "",
    "code": "FRA",
    "value": "FRA",
    "destination_translations": "",
    "language": "es",
    "country": "Deutschland"
  },
  {
    "id": 29305,
    "city": "Genova",
    "address": "",
    "code": "GOA",
    "value": "GOA",
    "destination_translations": "",
    "language": "es",
    "country": "Italia"
  },
  {
    "id": 29297,
    "city": "Gran Canaria",
    "address": "",
    "code": "LPA",
    "value": "LPA",
    "destination_translations": "",
    "language": "es",
    "country": "Spanien"
  },
  {
    "id": 29291,
    "city": "Iasi",
    "address": "",
    "code": "IAS",
    "value": "IAS",
    "destination_translations": "Iași\nIaşi\nIasi\nRoumanie\nRomânia\nRomania",
    "language": "es",
    "country": "Rumänien"
  },
  {
    "id": 29282,
    "city": "Istanbul",
    "address": "",
    "code": "IST",
    "value": "IST",
    "destination_translations": "",
    "language": "es",
    "country": "Türkei"
  },
  {
    "id": 29274,
    "city": "Izmir",
    "address": "",
    "code": "ADB",
    "value": "ADB",
    "destination_translations": "",
    "language": "es",
    "country": "Türkei"
  },
  {
    "id": 29263,
    "city": "Milan",
    "address": "",
    "code": "LIN",
    "value": "LIN",
    "destination_translations": "",
    "language": "es",
    "country": "Italia"
  },
  {
    "id": 29258,
    "city": "Lisabona",
    "address": "",
    "code": "LIS",
    "value": "LIS",
    "destination_translations": "",
    "language": "es",
    "country": "Portugal"
  },
  {
    "id": 29253,
    "city": "Londra",
    "address": "",
    "code": "LHR",
    "value": "LHR",
    "destination_translations": "",
    "language": "es",
    "country": "Vereinigtes Königreich"
  },
  {
    "id": 29247,
    "city": "Lyon",
    "address": "",
    "code": "LYS",
    "value": "LYS",
    "destination_translations": "",
    "language": "es",
    "country": "Frankreich"
  },
  {
    "id": 29242,
    "city": "Madrid",
    "address": "",
    "code": "MAD",
    "value": "MAD",
    "destination_translations": "",
    "language": "es",
    "country": "Spanien"
  },
  {
    "id": 29237,
    "city": "Malaga",
    "address": "",
    "code": "AGP",
    "value": "AGP",
    "destination_translations": "",
    "language": "es",
    "country": "Spanien"
  },
  {
    "id": 29232,
    "city": "Marsilia",
    "address": "",
    "code": "MRS",
    "value": "MRS",
    "destination_translations": "",
    "language": "es",
    "country": "Frankreich"
  },
  {
    "id": 29227,
    "city": "Montpellier",
    "address": "",
    "code": "MPL",
    "value": "MPL",
    "destination_translations": "",
    "language": "es",
    "country": "Frankreich"
  },
  {
    "id": 29212,
    "city": "Napoli",
    "address": "",
    "code": "NAP",
    "value": "NAP",
    "destination_translations": "",
    "language": "es",
    "country": "Italia"
  },
  {
    "id": 29202,
    "city": "Nisa",
    "address": "",
    "code": "NCE",
    "value": "NCE",
    "destination_translations": "",
    "language": "es",
    "country": "Frankreich"
  },
  {
    "id": 29197,
    "city": "Oradea",
    "address": "",
    "code": "OMR",
    "value": "OMR",
    "destination_translations": "",
    "language": "es",
    "country": "Rumänien"
  },
  {
    "id": 29192,
    "city": "Palermo",
    "address": "",
    "code": "PMO",
    "value": "PMO",
    "destination_translations": "",
    "language": "es",
    "country": "Italia"
  },
  {
    "id": 29187,
    "city": "Palma de Mallorca",
    "address": "",
    "code": "PMI",
    "value": "PMI",
    "destination_translations": "",
    "language": "es",
    "country": "Spanien"
  },
  {
    "id": 29182,
    "city": "Paris",
    "address": "",
    "code": "CDG",
    "value": "CDG",
    "destination_translations": "",
    "language": "es",
    "country": "Frankreich"
  },
  {
    "id": 29177,
    "city": "Pau",
    "address": "Pau Pyrénées Airport",
    "code": "PUF",
    "value": "PUF",
    "destination_translations": "",
    "language": "es",
    "country": "Frankreich"
  },
  {
    "id": 29172,
    "city": "Praga",
    "address": "",
    "code": "PRG",
    "value": "PRG",
    "destination_translations": "",
    "language": "es",
    "country": "Tschechien"
  },
  {
    "id": 29167,
    "city": "Riad",
    "address": "",
    "code": "RUH",
    "value": "RUH",
    "destination_translations": "",
    "language": "es",
    "country": "Saudi-Arabien"
  },
  {
    "id": 29162,
    "city": "Riga",
    "address": "",
    "code": "RIX",
    "value": "RIX",
    "destination_translations": "",
    "language": "es",
    "country": "Lettland"
  },
  {
    "id": 29157,
    "city": "Roma",
    "address": "",
    "code": "FCO",
    "value": "FCO",
    "destination_translations": "",
    "language": "es",
    "country": "Italia"
  },
  {
    "id": 29152,
    "city": "Salonic",
    "address": "",
    "code": "SKG",
    "value": "SKG",
    "destination_translations": "",
    "language": "es",
    "country": "Grecia"
  },
  {
    "id": 29142,
    "city": "Sofia",
    "address": "",
    "code": "SOF",
    "value": "SOF",
    "destination_translations": "",
    "language": "es",
    "country": "Bulgaria"
  },
  {
    "id": 29137,
    "city": "Strasbourg",
    "address": "",
    "code": "SXB",
    "value": "SXB",
    "destination_translations": "",
    "language": "es",
    "country": "Frankreich"
  },
  {
    "id": 29132,
    "city": "Suceava",
    "address": "",
    "code": "SCV",
    "value": "SCV",
    "destination_translations": "",
    "language": "es",
    "country": "Rumänien"
  },
  {
    "id": 29127,
    "city": "Tallin",
    "address": "",
    "code": "TLL",
    "value": "TLL",
    "destination_translations": "",
    "language": "es",
    "country": "Estonia"
  },
  {
    "id": 29122,
    "city": "Tampere",
    "address": "",
    "code": "TMP",
    "value": "TMP",
    "destination_translations": "",
    "language": "es",
    "country": "Finnland"
  },
  {
    "id": 29117,
    "city": "Tel Aviv",
    "address": "",
    "code": "TLV",
    "value": "TLV",
    "destination_translations": "",
    "language": "es",
    "country": "Israel"
  },
  {
    "id": 29112,
    "city": "Tenerife",
    "address": "",
    "code": "TFN",
    "value": "TFN",
    "destination_translations": "",
    "language": "es",
    "country": "Spanien"
  },
  {
    "id": 29107,
    "city": "Timisoara",
    "address": "",
    "code": "TSR",
    "value": "TSR",
    "destination_translations": "",
    "language": "es",
    "country": "Rumänien"
  },
  {
    "id": 29102,
    "city": "Torino",
    "address": "",
    "code": "TRN",
    "value": "TRN",
    "destination_translations": "",
    "language": "es",
    "country": "Italia"
  },
  {
    "id": 29097,
    "city": "Toulouse",
    "address": "",
    "code": "TLS",
    "value": "TLS",
    "destination_translations": "",
    "language": "es",
    "country": "Frankreich"
  },
  {
    "id": 29087,
    "city": "Venetia",
    "address": "",
    "code": "VCE",
    "value": "VCE",
    "destination_translations": "",
    "language": "es",
    "country": "Italia"
  },
  {
    "id": 29082,
    "city": "Viena",
    "address": "",
    "code": "VIE",
    "value": "VIE",
    "destination_translations": "",
    "language": "es",
    "country": "Austria"
  },
  {
    "id": 29077,
    "city": "Vilnius",
    "address": "",
    "code": "VNO",
    "value": "VNO",
    "destination_translations": "",
    "language": "es",
    "country": "Lituania"
  },
  {
    "id": 29062,
    "city": "Washington",
    "address": "",
    "code": "IAD",
    "value": "IAD",
    "destination_translations": "",
    "language": "es",
    "country": "Vereinigte Staaten"
  },
  {
    "id": 29071,
    "city": "Baia Mare",
    "address": "",
    "code": "BAY",
    "value": "BAY",
    "destination_translations": "",
    "language": "es",
    "country": "Rumänien"
  },
  {
    "id": 45610,
    "city": "A Coruna",
    "address": "A Coruna Airport",
    "code": "LCG",
    "value": "LCG",
    "destination_translations": "La Coruna\nLa Coruña\nA Coruña\nA Coruña Airport\nA Coruña Airport",
    "language": "es",
    "country": "Spanien"
  },
  {
    "id": 34310,
    "city": "New York",
    "address": "",
    "code": "JFK",
    "value": "JFK",
    "destination_translations": "",
    "language": "es",
    "country": "Vereinigte Staaten"
  },
  {
    "id": 32947,
    "city": "Tirana",
    "address": "Aeropuerto Internacional de Tirana Nënë Tereza",
    "code": "TIA",
    "value": "TIA",
    "destination_translations": "Tirana\nTiranë\nRinas\nAlbania\nShqipëri",
    "language": "es",
    "country": "Albania"
  },
  {
    "id": 44866,
    "city": "Dublin",
    "address": "Dublin Airport",
    "code": "DUB",
    "value": "DUB",
    "destination_translations": "",
    "language": "es",
    "country": "Irlanda"
  },
  {
    "id": 44874,
    "city": "Copenhaga",
    "address": "Copenhagen Airport",
    "code": "CPH",
    "value": "CPH",
    "destination_translations": "",
    "language": "es",
    "country": "Dänemark"
  },
  {
    "id": 44881,
    "city": "Gothenburg",
    "address": "Göteborg Landvetter Airport",
    "code": "GOT",
    "value": "GOT",
    "destination_translations": "",
    "language": "es",
    "country": "Schweden"
  },
  {
    "id": 44888,
    "city": "Stockholm",
    "address": "Stockholm Arlanda Airport",
    "code": "ARN",
    "value": "ARN",
    "destination_translations": "",
    "language": "es",
    "country": "Schweden"
  },
  {
    "id": 45587,
    "city": "Florenta",
    "address": "Amerigo Vespucci Airport",
    "code": "FLR",
    "value": "FLR",
    "destination_translations": "",
    "language": "es",
    "country": "Italia"
  },
  {
    "id": 45598,
    "city": "Reggio Calabria",
    "address": "Reggio Calabria Airport",
    "code": "REG",
    "value": "REG",
    "destination_translations": "",
    "language": "es",
    "country": "Italia"
  },
  {
    "id": 45604,
    "city": "Porto",
    "address": "Francisco Sá Carneiro Airport",
    "code": "OPO",
    "value": "OPO",
    "destination_translations": "",
    "language": "es",
    "country": "Portugal"
  },
  {
    "id": 45616,
    "city": "Vigo",
    "address": "Vigo Airport",
    "code": "VGO",
    "value": "VGO",
    "destination_translations": "",
    "language": "es",
    "country": "Spanien"
  },
  {
    "id": 45606,
    "city": "París",
    "address": "Aeropuerto de París-Orly",
    "code": "ORY",
    "value": "ORY", 
    "destination_translations": "",
    "language": "es",
    "country": "Francia"
  },
  {
    "id": 45607,
    "city": "Chișinău",
    "address": "Aeropuerto Internacional de Chișinău",
    "code": "RMO",
    "value": "RMO",
    "destination_translations": "",
    "language": "es",
    "country": "Moldavia"
  },
  {
    "id": 46001,
    "city": "Calgary",
    "address": "Aeropuerto Internacional de Calgary",
    "code": "YYC",
    "value": "YYC",
    "destination_translations": "Calgary\nCalgary Airport\nCanada",
    "language": "es",
    "country": "Canadá"
  },
  {
    "id": 46002,
    "city": "Toronto",
    "address": "Aeropuerto Internacional Toronto Pearson",
    "code": "YYZ",
    "value": "YYZ",
    "destination_translations": "Toronto\nToronto Pearson\nPearson\nCanada",
    "language": "es",
    "country": "Canadá"
  },
  {
    "id": 46003,
    "city": "Vancouver",
    "address": "Aeropuerto Internacional de Vancouver",
    "code": "YVR",
    "value": "YVR",
    "destination_translations": "Vancouver\nVancouver Airport\nCanada",
    "language": "es",
    "country": "Canadá"
  },
  {
    "id": 46004,
    "city": "Boston",
    "address": "Aeropuerto Internacional Logan",
    "code": "BOS",
    "value": "BOS",
    "destination_translations": "Boston\nLogan\nBoston Airport\nUnited States\nUSA",
    "language": "es",
    "country": "Estados Unidos"
  },
  {
    "id": 46005,
    "city": "Las Vegas",
    "address": "Aeropuerto Internacional Harry Reid",
    "code": "LAS",
    "value": "LAS",
    "destination_translations": "Las Vegas\nHarry Reid\nMcCarran\nUnited States\nUSA",
    "language": "es",
    "country": "Estados Unidos"
  },
  {
    "id": 46006,
    "city": "Los Ángeles",
    "address": "Aeropuerto Internacional de Los Ángeles",
    "code": "LAX",
    "value": "LAX",
    "destination_translations": "Los Angeles\nLAX\nUnited States\nUSA",
    "language": "es",
    "country": "Estados Unidos"
  },
  {
    "id": 46007,
    "city": "Seattle",
    "address": "Aeropuerto Internacional de Seattle-Tacoma",
    "code": "SEA",
    "value": "SEA",
    "destination_translations": "Seattle\nSeattle-Tacoma\nSeaTac\nUnited States\nUSA",
    "language": "es",
    "country": "Estados Unidos"
  },
  {
    "id": 46008,
    "city": "San Francisco",
    "address": "Aeropuerto Internacional de San Francisco",
    "code": "SFO",
    "value": "SFO",
    "destination_translations": "San Francisco\nSFO\nUnited States\nUSA",
    "language": "es",
    "country": "Estados Unidos"
  },
  {
    "id": 46009,
    "city": "Anchorage",
    "address": "Aeropuerto Internacional Ted Stevens Anchorage",
    "code": "ANC",
    "value": "ANC",
    "destination_translations": "Anchorage\nTed Stevens\nAlaska\nUnited States\nUSA",
    "language": "es",
    "country": "Estados Unidos"
  }
];

export default locationsEs;